import React from 'react'
import { Button, Modal } from 'react-bootstrap'

export default function ApproveCollection(props) {
  const { loadPopup, ClosePopup, approveCollection } = props
  return (
    <>
      <Modal
        show={loadPopup}
        dialogClassName='modal-90w'
        // fullscreen={'md-down'}
        onHide={() => ClosePopup()}
      >
        <Modal.Header closeButton>
          <Modal.Title>Approve</Modal.Title>
        </Modal.Header>
        <Modal.Body>{'Are you Sure to Approve this MovieCollection'}</Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => ClosePopup()}>
            Close
          </Button>
          <Button variant='primary' onClick={() => approveCollection()}>
            Approve
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
